<div
	[ngClass]="{ 'text-uc-green-700': !error(), 'text-uc-red-500': error() }"
	class="flex gap-2 font-semibold"
>
	<!-- error svg -->
	@if (error()) {
		<uc-exclamation-mark-round-svg customStyles="flex-shrink-0 w-6 h-6" />
	}

	<!-- success svg -->
	@if (!error()) {
		<uc-tick-svg customStyles="flex-shrink-0" />
	}

	<p>{{ message() }}</p>
</div>
